// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from "@leagueplatform/genesis-core";

export const questTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: "#FFFFFFFF",
        secondary: "#FAFAFAFF",
        tertiary: "#E8F8EEFF",
      },
      card: {
        primary: "#FAFAFAFF",
        secondary: "#FFFFFFFF",
        disabled: "#D1D1D1FF",
      },
      screenHeader: { background: "#E8F8EEFF" },
      skeleton: {
        shimmer: {
          background: "#E6E6E6FF",
          overlay:
            "linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)",
        },
      },
    },
    onSurface: {
      text: {
        primary: "#071D0FFF",
        subdued: "#646464FF",
        reversed: "#FFFFFFFF",
        critical: "#E2142CFF",
        success: "#348227FF",
        warning: "#956A27FF",
      },
      border: { subdued: "#E6E6E6FF", default: "#D1D1D1FF", card: "#E6E6E6FF" },
      icon: { primary: "#151515FF" },
    },
    interactive: {
      action: {
        primary: "#00854BFF",
        hovered: "#034C1FFF",
        pressed: "#034C1FFF",
        subdued: "#646464FF",
        disabled: "#D1D1D1FF",
      },
      icon: { default: "#FFFFFFFF", disabled: "#9A9A9AFF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#F5F5F5FF",
        hovered: "#E6E6E6FF",
        pressed: "#E6E6E6FF",
      },
      border: {
        default: "#808080FF",
        hovered: "#646464FF",
        disabled: "#D1D1D1FF",
        critical: { default: "#E1142CFF" },
      },
      focus: { inner: "#034C1FFF", outer: "#034C1FFF" },
    },
    critical: {
      background: { subdued: "#FFE9E5FF", secondary: "#FFFFFFFF" },
      border: { default: "#E2142CFF" },
      icon: "#E2142CFF",
    },
    warning: {
      background: { subdued: "#FFF9EBFF", secondary: "#FFFFFFFF" },
      border: { default: "#FEBA42FF" },
      icon: "#B5822FFF",
    },
    success: {
      background: { subdued: "#E7F0E6FF", secondary: "#FFFFFFFF" },
      border: { default: "#348227FF" },
      icon: "#348227FF",
    },
    highlight: {
      background: { subdued: "#EDF8FFFF", secondary: "#FFFFFFFF" },
      border: { default: "#2E5CDFFF" },
      icon: "#2E5CDFFF",
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#023616FF",
          dark: "#034C1FFF",
          default: "#00854BFF",
          bright: "#00C973FF",
          brightest: "#34F870FF",
          pastel: "#E8F8EEFF",
        },
        secondary: {
          darkest: "#0E264FFF",
          dark: "#064979FF",
          default: "#1382D3FF",
          bright: "#48B2FFFF",
          brightest: "#AADCFFFF",
          pastel: "#F1F9FFFF",
        },
        tertiary: {
          darkest: "#0F0027FF",
          dark: "#360F68FF",
          default: "#6619C9FF",
          bright: "#9A70F3FF",
          brightest: "#D8C9FAFF",
          pastel: "#FCF8FFFF",
        },
      },
    },
    primary: {
      background: {
        default: "#00854BFF",
        hovered: "#034C1FFF",
        pressed: "#071D0FFF",
        critical: {
          default: "#DA291CFF",
          hovered: "#B51414FF",
          pressed: "#DA291CFF",
        },
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } },
    },
    secondary: {
      background: {
        default: "#FFFFFFFF",
        hovered: "#E8F8EEFF",
        pressed: "#BDEBCFFF",
      },
      text: { default: "#034C1FFF", hovered: "#034C1FFF" },
      border: { default: "#00854BFF" },
    },
    tertiary: {
      background: {
        default: "#FFFFFF00",
        hovered: "#E8F8EEFF",
        pressed: "#BDEBCFFF",
      },
      text: { default: "#034C1FFF", hovered: "#034C1FFF" },
      border: { default: "#FFFFFFFF" },
    },
    input: {
      border: {
        success: "#00854BFF",
        warning: "#956A27FF",
        default: "#808080FF",
        hovered: "#646464FF",
        disabled: "#D1D1D1FF",
        critical: "#E1142CFF",
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#F5F5F5FF",
        hovered: "#E6E6E6FF",
        pressed: "#E6E6E6FF",
      },
    },
    dataViz: {
      interface: { track: { border: "#9A9A9AFF", background: "#F5F5F5FF" } },
      singleColor: { brand: "#034C1FFF", neutral: "#9A9A9AFF" },
      status: {
        critical: "#DA291CFF",
        warning: "#FEBA42FF",
        success: "#348227FF",
      },
      categorical: {
        one: "#034C1FFF",
        two: "#6516CCFF",
        three: "#1283D3FF",
        four: "#C62B5EFF",
        five: "#099697FF",
        six: "#F9A620FF",
      },
    },
    tag: {
      neutral: {
        background: { bold: "#646464FF", subdued: "#FAFAFAFF" },
        border: { bold: "#272727FF", subdued: "#151515FF" },
        text: { bold: "#FFFFFFFF", subdued: "#646464FF" },
      },
      one: {
        background: { bold: "#034C1FFF", subdued: "#E8F8EEFF" },
        border: { bold: "#023616FF", subdued: "#034C1FFF" },
        text: { bold: "#FFFFFFFF", subdued: "#034C1FFF" },
      },
      two: {
        background: { bold: "#34F870FF", subdued: "#E8F8EEFF" },
        border: { bold: "#00C973FF", subdued: "#34F870FF" },
        text: { bold: "#071D0FFF", subdued: "#034C1FFF" },
      },
      three: {
        background: { bold: "#6619C9FF", subdued: "#FCF8FFFF" },
        border: { bold: "#360F68FF", subdued: "#6619C9FF" },
        text: { bold: "#FFFFFFFF", subdued: "#6619C9FF" },
      },
      four: {
        background: { bold: "#004747FF", subdued: "#F0FFFFFF" },
        border: { bold: "#0A2A2AFF", subdued: "#004747FF" },
        text: { bold: "#F0FFFFFF", subdued: "#004747FF" },
      },
      success: {
        background: { bold: "#348227FF", subdued: "#F7FAF7FF" },
        border: { bold: "#194A11FF", subdued: "#348227FF" },
        text: { bold: "#FFFFFFFF", subdued: "#348227FF" },
      },
      warning: {
        background: { bold: "#FEBA42FF", subdued: "#FFF9EBFF" },
        border: { bold: "#FEBA42FF", subdued: "#956A27FF" },
        text: { bold: "#151515FF", subdued: "#956A27FF" },
      },
      critical: {
        background: { bold: "#E1142CFF", subdued: "#FFF8F6FF" },
        border: { bold: "#7D191AFF", subdued: "#E1142CFF" },
        text: { bold: "#FFFFFFFF", subdued: "#E2142CFF" },
      },
      informational: {
        background: { bold: "#2D6DDEFF", subdued: "#F7F9FEFF" },
        border: { bold: "#173D80FF", subdued: "#2D6DDEFF" },
        text: { bold: "#FFFFFFFF", subdued: "#2D6DDEFF" },
      },
    },
  },
  shadows: {
    card: { x: 0, y: 4, blur: 4, spread: -2, color: "#18274B0F" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" },
  },
  typography: {
    headingOne: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingTwo: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingThree: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingFour: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleOne: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 22,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleTwo: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOne: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOneSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwo: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwoSecondary: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    buttonOne: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    buttonTwo: {
      fontFamily:
        "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    label: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    overline: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none",
    },
    caption: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    tab: {
      fontFamily:
        "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 12,
    progressBar: 9999,
    tags: 4,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.375,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: {
    headings:
      "Figtree, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
  transitions: { defaultTime: "200ms" },
};
